import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

export default class CollectionService {

    getCollections(params, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/collections',
                method: 'get',
                params: params,
                withCredentials: true,
                headers: {                   
                    'Authorization': token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postCollection(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/collection',
                method: 'post',
                withCredentials: true,
                headers: {                   
                    'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putCollection(uuid, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/collection/' + uuid,
                method: 'put',
                withCredentials: true,
                headers: {                   
                    'Authorization': token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }



    deleteCollection(uuid, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/collection/' + uuid,
                method: 'delete',
                withCredentials: true,
                headers: {                   
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }


}